// extracted by mini-css-extract-plugin
export default {"verify-mobile-phone__button":"verify-mobile-phone_verify-mobile-phone__button__Btrf3"};